$(document).ready(function() {
    fixAllSVGs();

    $('.font-group-title').click(function() {
        let options = $(this).siblings('.font-group-options');
        if (options.is(':hidden')) {
            $('.font-group-options:visible').slideUp('fast');
            options.slideDown('fast');
        } else {
            options.slideUp('fast');
        }
    });
});

export function openModal(from, currentFont) {
    $('#font-fired-from').val(from);
    unselectFont();
    selectFont(currentFont);
    $('#font-modal').modal();
}

export function getDefaultFont() {
    let fontGroup = $('#font-modal .font-group:first');

    return fontGroup.find('.select-font:first');
}

export function unselectFont() {
    $('.select-font').removeClass('selected-font');
    $('.font-group-options').hide();
}

export function selectFont(font) {
    let selectedFont = $('.select-font[data-name="'+font+'"]');
    selectedFont.addClass('selected-font');
    //selectedFont.parent().show();
}